module.exports = __webpack_public_path__ + "img/user.9011be7d.png";